import React, { useState } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemCards } from './components/ProblemCards';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { StatsSection } from './components/StatsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyBottomCTA } from './components/StickyBottomCTA';
import { LegalModals } from './components/LegalModals';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <div className="w-full min-h-screen bg-[var(--dark)]" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemCards data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ForWhomSection data-id="element-5" />
      <IncludesSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <StatsSection data-id="element-11" />
      <HowItWorksSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalCTASection data-id="element-14" />
      <Footer onOpenPrivacy={() => setShowPrivacy(true)} onOpenTerms={() => setShowTerms(true)} data-id="element-15" />
      <StickyBottomCTA data-id="element-16" />
      <LegalModals showPrivacy={showPrivacy} showTerms={showTerms} onClosePrivacy={() => setShowPrivacy(false)} onCloseTerms={() => setShowTerms(false)} data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}